// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';
import NavButton from '../navButton';

export default styled<typeof NavButton, Theme, _>(NavButton)`
  &::before {
    content: '›';
    margin-right: 0;
  }
  right: 0.5rem;
`;
